import React from 'react';
import { Sections } from '../../../components/Sections';

export const MainContents = () => {
  return <Sections type={'MAIN'} />;
};
